import { getSequence } from 'src/tools'
import { arrayToList } from './tools'
import { Inline } from './components/inline'
import { Area } from './components/area'
import { Grid } from './components/grid'
import { Baskets } from './components/baskets'
import { Picture } from './components/picture'

export const Playground = () => (
  // getSequence({ minValue: 1, maxValue: 10 })
  // getSequence({ minValue: 1, maxValue: 10 })
  // getSequence({ minValue: 1, maxValue: 10 })
  // getSequence({ minValue: 1, maxValue: 10 })

  <div>
    <Inline
      title="1. Put these numbers in order from <b>least</b> to <b>greatest</b>"
      items={arrayToList([1, 9, 7, 2])}
    />
    <div className="break-40"> </div>

    <Inline
      title="2. Put these numbers in order from <b>greatest</b> to <b>least</b>"
      items={arrayToList([6, 5, 8, 1, 4, 3])}
    />

    <div className="break-40"> </div>

    <Inline
      title="3. Put these fractions in order from <b>least</b> to <b>greatest</b>"
      items={arrayToList([
        '<div class="fraction"><span class="top">2</span><span class="bottom">6</span></div>',
        '<div class="fraction"><span class="top">1</span><span class="bottom">6</span></div>',
        '<div class="fraction"><span class="top">4</span><span class="bottom">6</span></div>',
        '<div class="fraction"><span class="top">6</span><span class="bottom">6</span></div>',
        '<div class="fraction"><span class="top">5</span><span class="bottom">6</span></div>',
        '<div class="fraction"><span class="top">3</span><span class="bottom">6</span></div>',
      ])}
    />
    <div className="break-40"> </div>

    <Grid
      title="4. Use the unit squares to cover the rectangle."
      width={2}
      height={4}
    />
    <div className="break-40"> </div>

    <Grid
      title="5. Use the unit squares to cover the rectangle."
      width={6}
      height={2}
    />
    <div className="break-40"> </div>

    <Baskets
      title="6. Place each product into the correct box."
      baskets={[
        { id: 'basket-1', title: 'less then 1' },
        { id: 'basket-2', title: 'equal to 1' },
        { id: 'basket-3', title: 'greater then 1' },
      ]}
      items={arrayToList([
        '<div class="math-item">4 ×<div class="fraction"><span class="top">2</span><span class="bottom">3</span></div></div>',
        '<div class="math-item"><div class="fraction"><span class="top">2</span><span class="bottom">3</span></div> × 5</div>',
        '<div class="math-item"><div class="fraction"><span class="top">2</span><span class="bottom">3</span></div> × 2</div>',
      ])}
    />
    <div className="break-40"> </div>

    <Baskets
      title="7. Even or Odd."
      baskets={[
        { id: 'basket-1', title: 'Even' },
        { id: 'basket-2', title: 'Odd' },
      ]}
      items={arrayToList([2, 17, 6, 3, 9, 21, 15, 6, 8])}
    />
    <div className="break-40"> </div>

    <Picture
      title="8. Put 2 bat in the picture."
      items={arrayToList([1, 2, 3, 4, 5, 6])}
    />
    <div className="break-40"> </div>

    {/*
      <Baskets
        title='6. Order the colors to show the size of the force applied to each ballon.'
        baskets={

        }
        items={
          arrayToList([
            'coral',
            'cyan',
            'magenta',
            'turquoise',
            'violet',
          ])}
      />
      <div className='break-40'>

      */}
  </div>
)
